import React from 'react';
import { ProjectHistoryStats } from './ProjectHistoryStats';
import { ProjectHistoryModuleDistribution } from './ProjectHistoryModuleDistribution';
import { ProjectHistoryQuickFilters } from './ProjectHistoryQuickFilters';

export function ProjectHistorySidebar({ data }: { data: any }) {
  return (
    <div className="space-y-6">
      {/* Thống kê lịch sử */}
      <ProjectHistoryStats />

      {/* Phân bổ theo phân hệ */}
      <ProjectHistoryModuleDistribution items={data.moduleDistribution} />

      {/* Bộ lọc nhanh */}
      <ProjectHistoryQuickFilters />
    </div>
  );
}
